import { z } from 'zod';

const geoRegion = z.object({
    uri: z.literal('/geo/region'),
    neighbors: z.string().optional(),
    friendlyName: z.string(),
    id: z.string(),
    value: z.string(),
    label: z.string(),
    level: z.number(),
});
const geoRegions = z.object({
    regions: z.array(geoRegion),
});
const geoCity = z.object({
    uri: z.literal('/geo/city'),
    istat: z.string(),
    regionId: z.string(),
    shortName: z.string(),
    friendlyName: z.string(),
    id: z.string(),
    value: z.string(),
    label: z.string(),
    level: z.number(),
});
const geoTown = z.object({
    uri: z.literal('/geo/town'),
    istat: z.string(),
    regionId: z.string(),
    cityId: z.string(),
    hasZone: z.boolean(),
    friendlyName: z.string(),
    id: z.string(),
    value: z.string(),
    label: z.string(),
    level: z.number(),
});
const geoZone = z.object({
    uri: z.literal('/geo/zone'),
    regionId: z.string(),
    cityId: z.string(),
    townId: z.string(),
    id: z.string(),
    value: z.string(),
    label: z.string(),
    level: z.number(),
});
const geoZones = z.object({
    zones: z.array(geoZone),
});
const itemMap = z.object({
    zoom: z.string(),
    latitude: z.string(),
    longitude: z.string(),
    address: z.string().optional(),
    showPin: z.boolean().optional(),
});
const itemGeo = z.object({
    uri: z.literal('/geo'),
    type: z.string(),
    label: z.string(),
    region: geoRegion,
    city: geoCity.optional(),
    town: geoTown.optional(),
    zone: geoZone.optional(),
    map: itemMap.optional(),
});
const geoZipCode = z.object({
    zipCode: z.string(),
    town: z.string(),
    province: z.string(),
});
const geoZipCodes = z.array(geoZipCode);
const geoEntry = z.object({
    region: geoRegion,
    city: geoCity.optional(),
    town: geoTown.optional(),
    zone: geoZone.optional(),
});
const geoEntries = z.object({
    entries: z.array(geoEntry).optional(),
});

export { geoCity, geoEntries, geoEntry, geoRegion, geoRegions, geoTown, geoZipCode, geoZipCodes, geoZone, geoZones, itemGeo, itemMap };
//# sourceMappingURL=zod.js.map
